import "./style.scss";
import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {
    setActivityIndicator,
    setModals,
} from "../../redux/slices/appconfigSlice";
import {useDispatch, useSelector} from "react-redux";
import {RegisterService} from "../../services/RegisterService";
import {getLoginConfig, setIsLogin, setLoginUser} from "../../redux/slices/loginconfigSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {toast} from "react-toastify";
import PropTypes from "prop-types";
import {faEye, faEyeSlash} from "@fortawesome/free-regular-svg-icons";
import SocialLogins from "../SocialLogins";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import {ServicePostUserObject} from "../../services/NotificationService";

const SignUpModal = (props) => {
    const {T} = useTranslationCustom();
    const dispatch = useDispatch();
    const loginConfig = useSelector(getLoginConfig);
    const [form, setForm] = useState({email: "", password: ""});
    const [inputType, setInputType] = useState(false);

    useEffect(() => {
        if (!props.show) {
            setForm({email: "", password: ""});
        }
    }, [props.show]);

    const onRegisterHandler = (e) => {
        e.preventDefault();

        if (
            form.password.match(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
            ) === null
        ) {
            toast.info(T("Profile:Password_Info"));
            return;
        }

        dispatch(setModals({login: false, register: false, confirmation: false}));
        const params = {
            username: form.email,
            password: form.password,
            firstname: "",
            lastname: "",
            Locale: loginConfig?.locale?.code
        };
        dispatch(setActivityIndicator(true));
        RegisterService(params)
            .then(async (response) => {
                params.email = form.email;
                params.guid = response.guid;

                try {
                    const _response = await ServicePostUserObject({
                        email: params?.username || '',
                        name: params?.firstname + ' ' + params?.lastname || '',
                        first_name: params?.firstname || '',
                        last_name: params?.lastname || '',
                        external_user_id: response.guid,
                        social_provider: null,
                    });
                    console.log({_response});
                } catch (err) {
                    console.log(err);
                } finally {
                    dispatch(setActivityIndicator(false));
                }

                delete params["password"];
                dispatch(setActivityIndicator(false));
                dispatch(setLoginUser(params));
                dispatch(setIsLogin(true));
                toast.success(T("Toasts:Toast_Description_Login_Successfully"));
            })
            .catch((error) => {
                dispatch(setActivityIndicator(false));
                console.log({error});
                if (error?.response?.status === 400) {
                    toast.error(
                        error?.response?.data?.errors[0]?.description?.toString()
                    );
                }
                if (error?.response?.status === 401) {
                    toast.error(error?.response?.data?.message?.toString());
                }
            });
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h4 className="fs-38 medium">
                    {T("Home:Home_Signup_Modal_Heading")} <span className="bold green-text">Genius®</span>
                </h4>
                <form className="auth-form" onSubmit={onRegisterHandler}>
                    <div className="signup-form">
                        <div className="form-group">
                            <input
                                type="email"
                                placeholder={T("Home:Home_Signup_Modal_Email_Placeholder")}
                                name="email"
                                id="email"
                                value={form.email}
                                required={true}
                                onChange={(e) => setForm({...form, email: e.target.value})}
                            />
                        </div>
                        <div className="form-group password-field">
                            <input
                                type={inputType ? "text" : "password"}
                                placeholder={T("Home:Home_Login_Modal_Password_Placeholder")}
                                name="password"
                                id="password"
                                value={form.password}
                                required={true}
                                onChange={(e) => setForm({...form, password: e.target.value})}
                            />
                            <FontAwesomeIcon onClick={() => setInputType(!inputType)} className="eyeicon"
                                             icon={!inputType ? faEye : faEyeSlash}/>
                        </div>
                        <div className="form-group login-btn">
                            <button className="submit-btn btn-primary" type="submit">
                                {T('Buttons:Signup')}
                            </button>
                        </div>
                    </div>
                    <div className="action link">
                        <p className="m-0 fs-12">
                            {T("Home:Home_Signup_Modal_Already_Have_Account")}?{" "}
                            <a
                                className="green-text static-link"
                                onClick={() =>
                                    dispatch(
                                        setModals({
                                            login: true,
                                            register: false,
                                            confirmation: false,
                                        })
                                    )
                                }
                            >
                                {T("Home:Home_Login_Modal_Heading")}
                            </a>
                        </p>
                    </div>

                    <SocialLogins/>

                </form>
            </Modal.Body>
        </Modal>
    )
        ;
};

SignUpModal.propTypes = {
    show: PropTypes.bool,
};

export default SignUpModal;
